import { Organisation, OrganisationType, User } from './types';

export enum DocsAccessTier {
  NONE = 'NONE',
  LAB = 'LAB',
  PROVIDER = 'PROVIDER',
  RESISTOMAP = 'RESISTOMAP',
}

const organisationTypeToDocsAccessTier: Partial<Record<OrganisationType, DocsAccessTier>> = {
  [OrganisationType.LAB]: DocsAccessTier.LAB,
  [OrganisationType.PROVIDER]: DocsAccessTier.PROVIDER,
  [OrganisationType.RESISTOMAP]: DocsAccessTier.RESISTOMAP,
};

type UserWithOrganisations = Pick<User, 'organisations'> | null | undefined;

export function resolveDocsAccessTierFromOrganisations(
  organisations: Organisation[] | null | undefined,
): DocsAccessTier {
  const organisationTiers = new Set(
    (organisations ?? []).map(organisation => organisationTypeToDocsAccessTier[organisation.type] ?? DocsAccessTier.NONE),
  );

  if (organisationTiers.has(DocsAccessTier.RESISTOMAP)) {
    return DocsAccessTier.RESISTOMAP;
  }

  // Provider and lab bundles are not nested: combined membership needs the union bundle.
  if (organisationTiers.has(DocsAccessTier.LAB) && organisationTiers.has(DocsAccessTier.PROVIDER)) {
    return DocsAccessTier.RESISTOMAP;
  }

  if (organisationTiers.has(DocsAccessTier.PROVIDER)) {
    return DocsAccessTier.PROVIDER;
  }

  if (organisationTiers.has(DocsAccessTier.LAB)) {
    return DocsAccessTier.LAB;
  }

  return DocsAccessTier.NONE;
}

export function resolveDocsAccessTier(user: UserWithOrganisations): DocsAccessTier {
  return resolveDocsAccessTierFromOrganisations(user?.organisations);
}

export function canAccessLabDocs(user: UserWithOrganisations): boolean {
  return resolveDocsAccessTier(user) !== DocsAccessTier.NONE;
}
